module.exports = __webpack_public_path__ + "static/media/IMG_045.e861a63a.jpg";